import styled, { css } from 'styled-components';
import { FlexContainer, colors as colors_ } from '@taxdown/piccolo-web';

export const authAnimation = css`
  @keyframes anigrad {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -200vw 0%;
    }
  }
  background: linear-gradient(
    45deg,
    #dff8e9 0%,
    #eef7fd 9.38%,
    #ffede9 16.15%,
    #eef7fd 29.17%,
    #dff8e9 46.88%,
    #eef7fd 57.81%,
    #ffede9 65.63%,
    #eef7fd 82.81%,
    #dff8e9 96.88%
  );
  background-size: 200vw 200vw;
  animation: anigrad 4s linear infinite;
`;

export const LoaderContainer = styled(FlexContainer)`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: ${colors_.iridiscent_gradient};
  ${authAnimation}
`;

export const LottieContainer = styled.div`
  width: 120px;
  height: 120px;
`;
